<template>
  <div>
    <div class="has-background-white is-border is-fullwidth">
      <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
        <div class="is-size-5 is-uppercase">
          Données Clients :
        </div>
      </div>
      <div
        v-for="(buyerExt, index) in getBuyers"
        :key="buyerExt.pk+index"
        class="has-background-light is-padding is-border-bottom">
        <div class="columns is-multiline">
          <div class="column is-4">
            <label class="label is-small is-size-7 truncate">Prénom</label>
            <div class="is-borderless is-medium is-fullwidth">
              {{ buyerExt.first_name }}
            </div>
          </div>
          <div class="column is-4">
            <label class="label is-small is-size-7 truncate">Nom</label>
            <div class="is-borderless is-medium is-fullwidth">
              {{ buyerExt.last_name }}
            </div>
          </div>
          <div
            v-if="index == 0"
            class="column is-4">
            <label class="label is-small is-size-7 truncate">ID externe</label>
            <div class="control">
              <v-input
                :id="'external_id' + index"
                :name="'external_id'+index"
                @input="val => modifyBuyer(val, index)"
                :model="buyerExt.external_id"
                :errors-bag="errors"
                data-vv-value-path="val"
                classes="input"
                data-vv-as="ID externe">
              </v-input>
            </div>
          </div>
        </div>
      </div>
      <div
        class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
        <div class="is-size-5 is-uppercase">
          Données Vendeurs :
        </div>
      </div>
      <div
        v-if="adv.status === 'pre_reserved'"
        class="has-background-light is-padding is-border-bottom">
        <div class="columns is-multiline">
          <div class="column is-4">
            <label class="label is-small is-size-7 truncate">Prénom</label>
            <div class="is-borderless is-medium is-fullwidth">
              {{ adv.seller_data.first_name }}
            </div>
          </div>
          <div class="column is-4">
            <label class="label is-small is-size-7 truncate">Nom</label>
            <div class="is-borderless is-medium is-fullwidth">
              {{ adv.seller_data.last_name }}
            </div>
          </div>
          <div class="column is-4">
            <label class="label is-small is-size-7 truncate">ID externe</label>
            <div class="control">
              <v-input
                id="external_id"
                name="external_id"
                @input="val => modifySeller(val, adv.seller_data.pk)"
                :errors-bag="errors"
                :model="adv.user.account.account_type === 'promoteur' ? adv.seller_data.external_id : adv.seller_data.account.external_id"
                data-vv-value-path="val"
                classes="input"
                data-vv-as="ID externe">
              </v-input>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        v-for="(seller, index) in adv.seller_to_send"
        :key="seller.pk+index"
        class="has-background-light is-padding is-border-bottom">
        <div class="columns is-multiline">
          <div class="column is-4">
            <label class="label is-small is-size-7 truncate">Prénom</label>
            <div class="is-borderless is-medium is-fullwidth">
              {{ seller.first_name || seller[1].user.first_name }}
            </div>
          </div>
          <div class="column is-4">
            <label class="label is-small is-size-7 truncate">Nom</label>
            <div class="is-borderless is-medium is-fullwidth">
              {{ seller.last_name || seller[1].user.last_name }}
            </div>
          </div>
          <div class="column is-4">
            <label class="label is-small is-size-7 truncate">ID externe</label>
            <div class="control">
              <v-input
                :id="'external_id' + index"
                :name="'external_id'+ index"
                @input="val => modifySeller(val, index)"
                :errors-bag="errors"
                :model="seller.external_id != null ? seller.external_id : seller.account.external_id"
                data-vv-value-path="val"
                classes="input"
                data-vv-as="ID externe">
              </v-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="is-fullwidth">
      <submit-sticky-buttons
        v-if="hasModify"
        :cancel="appelCancel"
        @submit="updateAdvExternalConnection"
        button-id="advInfos"
        :loading="submitLoading"></submit-sticky-buttons>
    </div>
  </div>
</template>

<script>
import AdvMixin from '@/mixins/AdvMixin'
export default {
  name: 'ExternalConnectionGrimmo',
  mixins: [AdvMixin],
  data () {
    return {
      hasModify: false
    }
  },
  methods: {
    modifyBuyer (val, index) {
      if (this.hasModify === false) {
        this.hasModify = true
      }
      this.updateExternalIdContact(val, index)
    },
    modifySeller (val, index) {
      if (this.hasModify === false) {
        this.hasModify = true
      }
      this.updateExternalIdSeller(val, index)
    }
  }
}
</script>
